import component from './services-menu';

export default function install(Vue, options) { // eslint-disable-line no-unused-vars
  Vue.component(component.name, component);
}
